<template>
	<div class="flexCol alit">
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E5%8D%83%E5%AF%BBAI/%E5%A4%B4%E9%83%A8%E5%B9%BF%E5%91%8A.png"
			alt="" style="height: 90vh;" />
		<div class="title" style="margin-top: 30px;margin-bottom: 5px;">农业产业AI大模型--AI全域农业专家</div>
		<div class="title-desc">引领农业产业智慧化全新变革 破解农业生产标准化难题</div>

		<div class="flex justc">
			<div class="flex alit justc" style="width: 100%;">
				<div class="chat">
					<div class="chat-cont" id="chat">
						<div class="" v-for="item in newsList">
							<div class="flex" v-if="item.type == 'to'">
								<div class="leftnews">{{item.content}}</div>
							</div>
							<div class="flex" v-if="item.type == 'loading'">
								<div class="leftnews">加载中</div>
							</div>
							<div class="flex justb" v-if="item.type == 'from'">
								<div class=""></div>
								<div class="rightnews">{{item.content}}</div>
							</div>

						</div>
					</div>
					<div class="chart-input flex alit">
						<input type="text" class="" v-model="inputText" @keyup.enter="sendMessage" />
						<img class="send"
							src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E5%8D%83%E5%AF%BBAI/sendBlue.png"
							alt="" @click="sendMessage" />
					</div>
				</div>
				<div class="flexCol" style="width: 30%;margin-left: 20px;">
					<div class="title2">深度推理能力</div>
					<div class="title2">结合实际应用场景感知您所需要的</div>
					<div class="desc2">基于农业全域知识库、农业产业大数据、多模型综合训练等，打造简单、高效、专业的AI全域农业专家，
						结合实际场景通过文字、图片、文件等多种方式展现，给予更系统更全面的全方位推荐。</div>
					<div class="lxwm" @click="concatUs">联系我们</div>
				</div>
			</div>
		</div>
		<div class="flexCol alit" style="background-color: #e6fbff;width: 100%;padding-bottom: 30px;margin: 20px 0 0 0;">
			<div class="title" style="margin-top: 40px;margin-bottom: 15px;">市场价值</div>
			<div class="title-desc">构建人工智能新生态，助力产业精细化发展</div>

			<div class="flex alit justc" >
				<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E5%8D%83%E5%AF%BBAI/%E5%BA%95%E9%83%A8%E5%B9%BF%E5%91%8A.png"
					alt="" class="scjzimage" />
				<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E5%8D%83%E5%AF%BBAI/aiLine.png"
					alt="" style="height: 45vh;width: auto;margin: 0 30px 0 60px;" />
				<div class="flexCol justb" style="height: 43vh;">
					<div class="jz-cont">
						<div class="jz-title">社会价值</div>
						<div class="jz-desc">大模型加速AI产业化革命进程<br />
							深度场景结合降低AI使用门槛</div>
					</div>
					<div class="jz-cont">
						<div class="jz-title">经济价值</div>
						<div class="jz-desc">提升行业效率及生产力<br />
							实现产业效益倍数增长</div>
					</div>
					<div class="jz-cont">
						<div class="jz-title">社会价值</div>
						<div class="jz-desc">AI助力打造乡村全产业链“智慧大脑”</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <img style="width: 80%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E5%B9%BF%E7%A7%AF%E7%B2%AE%E5%A4%A7%E6%A8%A1%E5%9E%8B/%E9%AB%98%E4%BA%A7%E6%96%B9%E6%A1%88.png"
			alt="" />
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">模型价值</div>
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E5%B9%BF%E7%A7%AF%E7%B2%AE%E5%A4%A7%E6%A8%A1%E5%9E%8B/%E6%A8%A1%E5%9E%8B%E4%BB%B7%E5%80%BC2.png"
			alt="" /> -->

		<img style=""
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E5%8D%83%E5%AF%BBAI/%E5%BA%95%E9%83%A8%E5%B9%BF%E5%91%8A.png"
			alt="" />


	</div>
</template>

<script setup>
	import {
		ref,
		onMounted,
	} from 'vue'
	import http from '@/utils/request.js'; // 根据你的项目结构调整导入路径
	const inputText = ref()
	const newsList = ref([])
	const sendCode = ref()
	import {
		useRouter
	} from 'vue-router';
	const router = useRouter();
	function concatUs(){
		router.push('/concatUs')
	}
	onMounted(() => {
		http.get('/app-api/ai/xunFei/apiPass').then(res => {
			sendCode.value = res.data
			console.log(sendCode.value);
		})
		changeScroll()
		var i = 0
		// const int = setInterval(function() {
		// 	newsList.value.push({
		// 		type: 'to',
		// 		content: '啊哈哈哈哈哈'
		// 	})
		// 	i++
		// 	if (i == 5) {
		// 		clearInterval(int)
		// 	}
		// 	setTimeout(function() {
		// 		changeScroll()
		// 	}, 0)
		// }, 1000)
	})

	function sendMessage() {
		newsList.value.push({
			type: 'from',
			content: inputText.value
		})
		setTimeout(function() {
			changeScroll()
		}, 0)
		setTimeout(function() {
			newsList.value.push({
				type: 'loading',
				content: inputText.value
			})
			setTimeout(function() {
				changeScroll()
			}, 0)
		}, 1000)

		http.get(`/app-api/ai/xunFei/ultra?userId=12313&content=${inputText.value}`).then(res => {
			// sendCode.value = res.data
			console.log(res);
			newsList.value[newsList.value.length - 1] = {
				type: 'to',
				content: ''
			}
			var i = 0
			var interval = setInterval(function() {
				newsList.value[newsList.value.length - 1].content += res.data[i]
				if (i == res.data.length - 1) {
					clearInterval(interval)
				}
				changeScroll()
				i++;
			}, 30)
			// for (var i = 0; i < res.data.length; i++) {
			// 	newsList.value[newsList.value.length - 1].content += res.data[i]
			// }
			// newsList.value.push({
			// 	type: 'to',
			// 	content: res.data
			// })
			setTimeout(function() {
				changeScroll()
			}, 0)
		})
		// http.post('/api/v1/chat/completions',{
		// 	"model": "4.0Ultra",
		// 	"user": "123456",
		// 	"messages": [{
		// 		"role": "system",
		// 		"content": "你是千寻AI，你属于重庆千广科技有限公司"
		// 	}, {
		// 		"role": "user",
		// 		"content": inputText.value
		// 	}],
		// 	// 下面是可选参数
		// 	"stream": true,
		// 	"tools": [{
		// 		"type": "web_search",
		// 		"web_search": {
		// 			"enable": true,
		// 			"search_mode": "deep"
		// 		}
		// 	}],
		// 	"max_tokens": 500
		// },{
		// 	headers: {
		// 		'Authorization': 'Bearer VsFDfesdQAPelaopxmOe:LOfrwouDHNiviPkyRgWr',// + sendCode.value,
		// 		"content-type": "application/json"
		// 	}
		// })
		inputText.value = ''

	}

	function changeScroll() {
		const scrollContainer = document.getElementById('chat');
		// 平滑滚动到底部
		// scrollContainer.scrollTo({
		// 	top: scrollContainer.scrollHeight,
		// 	behavior: 'smooth' // 可选: 'auto' 或 'smooth'
		// });
		// 或者直接滚动
		scrollContainer.scrollTo(0, scrollContainer.scrollHeight);
	}
</script>

<style lang="scss" scoped>
	.jz-cont:hover{
		scale: 1.05;
	}
	.jz-cont {
		width: 20vw;
		background: linear-gradient(0deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.5) 100%);
		padding: 10px 20px;
		border-radius: 10px;
		cursor: pointer;
		.jz-title{
			color: #2768EA;
			font-size: 24px;
			font-weight: 700;
		}
		.jz-desc{
			font-size: 18px;
			margin-top: 10px;
		}
	}

	.scjzimage {
		width: 37%;
		height: 40vh;
	}

	.lxwm {
		background-color: #2768EA;
		width: 100px;
		text-align: center;
		line-height: 40px;
		color: #fff;
		border-radius: 10px;
		margin-top: 10px;
		cursor: pointer;
		font-size: 18px;
	}

	.title2 {
		font-size: 22px;
		font-weight: 700;
		margin-bottom: 20px;
	}

	.desc2 {}

	.rightnews {
		max-width: 94%;
		padding: 10px;
		background-color: #2768EA;
		color: #fff;
		margin-bottom: 20px;
		margin-right: 1%;
		border-radius: 10px;
	}

	.leftnews {
		max-width: 94%;
		background-color: #fff;
		box-shadow: 0px 2px 23px 1px rgba(41, 108, 246, 0.08);
		margin-bottom: 20px;
		padding: 10px;
		margin-left: 20px;
		border-radius: 10px;
	}

	.chat::after {
		content: "";
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
		background: #C4E0FF;
		border-radius: 4px;
		border: 2px solid #89C3FF;
		opacity: 0.2;
	}

	.chat {
		width: 40vw;
		max-height: 400px;
		position: relative;

		.chat-cont {
			height: 300px;
			max-height: 400px;
			overflow-y: auto;
			overflow-x: hidden;
			position: relative;
			z-index: 3;
			padding-top: 20px;
		}

		/* 整个滚动条 */
		::-webkit-scrollbar {
			width: 5px;
			/* 垂直滚动条宽度 */
			height: 5px;
			/* 水平滚动条高度 */
		}

		/* 滚动条轨道 */
		::-webkit-scrollbar-track {
			background: none;
			border-radius: 4px;
		}

		/* 滚动条滑块 */
		::-webkit-scrollbar-thumb {
			background: #c1c1c1;
			border-radius: 4px;
		}

		/* 滚动条滑块悬停状态 */
		::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}

		/* 滚动条按钮（上下箭头） */
		::-webkit-scrollbar-button {
			display: none;
			/* 隐藏箭头按钮 */
		}

		.chart-input {
			width: 95%;
			margin-left: 2.5%;
			height: 40px;
			background: #FFFFFF;
			box-shadow: 0px 2px 23px 1px rgba(41, 108, 246, 0.08);
			position: relative;
			z-index: 3;
			border-radius: 15px;
			margin-bottom: 10px;

			input {
				width: 100%;
				border: none;
				height: 30px;
				font-size: 22px;
				padding-left: 10px;
			}

			input:focus {
				outline: none;
				/* 移除默认的outline */
				border: 2px solid transparent;
				/* 边框设置为透明 */
				border: 0;
			}

			.send {
				width: 20px;
				height: 20px;
				padding: 0 20px;
				cursor: pointer;
			}
		}
	}

	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 70%;
		font-size: 22px;
	}

	img {
		width: 100%;
		height: auto;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>